import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-form-checkbox',
  templateUrl: './form-checkbox.component.html',
  styleUrls: ['./form-checkbox.component.sass'],
})
export class FormCheckboxComponent implements OnInit {
  @Input() title: string = '';
  @Input() control = new FormControl();
  constructor() {}

  ngOnInit(): void {}
}
